import { ChangeEvent, useState } from "react";

import { useTranslator } from "@eo-locale/react";

import { string } from "yup";

import {
  FormControl,
  FormLabel,
  FormHelperText,
  FormErrorMessage,
  FormErrorIcon,
  HTMLWrapper,
  Textarea,
  VisuallyHidden
} from "@/storybook-components";
import type { Question } from "../question";

export const validate = async (
  answer: string,
  question: Question
): Promise<string[]> => {
  let schema = string();
  if (question.required) {
    schema = schema.required();
  }
  try {
    await schema.validate(answer);
    return [];
  } catch (err: any) {
    return err.errors;
  }
};

function EssayQuestion(props: Question): JSX.Element {
  const {
    id,
    question,
    required,
    error,
    status,
    onChangeHandler,
    notes,
    existingValue
  } = props;
  const { translate } = useTranslator();

  const [inputText, setInputText] = useState(existingValue || "");

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    setInputText(event.target.value);
    if (onChangeHandler) onChangeHandler(event.target.value);
  };

  return (
    <FormControl
      my={4}
      id={`${id}`}
      isInvalid={error?.length > 0 || false}
      isRequired={required || false}
      isDisabled={status === "saving"}
      className={error?.length > 0 ? "ehqQuestionError" : ""}
    >
      <FormLabel>
        <HTMLWrapper html={question} />
        {required && (
          <VisuallyHidden>{`* ${translate("common.required")}`}</VisuallyHidden>
        )}
      </FormLabel>
      <Textarea
        value={inputText}
        onChange={handleChange}
        size={{ base: "lg", lg: "md" }}
        data-testid="essayQuestion-input"
        fontSize="md !important"
        fontWeight="normal"
      />
      {error?.length > 0 && (
        <FormErrorMessage data-testid="essayQuestion-errorMessage">
          <FormErrorIcon />
          {translate(`errors.${error}`)}
        </FormErrorMessage>
      )}
      <FormHelperText>{notes || ""}</FormHelperText>
    </FormControl>
  );
}

export { EssayQuestion };
